import { transparentize } from 'polished';
import c from '../colors';
import { setAlpha } from '../utils';

/**
 * @see http://livingston.sas.com/10-0/essentials/standard/
 */
export const stateStandard = {
  normal(theme) {
    switch (theme.baseReportThemeName) {
      case 'marine':
      case 'sail':
        return {
          fg: c.n_3(theme),
          bg: c.white(theme),
          bd: c.n1(theme),
          filter: 'none'
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: c.white(theme),
          bg: transparentize(0.95, c.white(theme)),
          bd: c.white(theme),
          filter: 'none'
        };
      case 'high-contrast':
        return {
          fg: c.white(theme),
          bg: c.black(theme),
          bd: c.white(theme),
          filter: 'none'
        };
      default:
        return {
          fg: c.n_3(theme),
          bg: transparentize(0.9, c.n1(theme)),
          bd: c.n1(theme),
          filter: 'none'
        };
    }
  },
  hover(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.hcStandardSelected(theme),
          bg: c.hcStandardHover(theme),
          bd: c.hcStandardSelected(theme),
          filter: 'none'
        };
      case 'marine':
      case 'sail':
        return {
          fg: c.n_3(theme),
          bg: c.p4(theme),
          bd: c.n1(theme),
          filter: 'none'
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: c.white(theme),
          bg: transparentize(0.9, c.white(theme)),
          bd: c.white(theme),
          filter: 'none'
        };
      case 'high-contrast':
        return {
          fg: c.white(theme),
          bg: c.n_3(theme),
          bd: c.white(theme),
          filter: 'none'
        };
      default:
        return {
          fg: c.n_3(theme),
          bg: transparentize(0.8, c.n1(theme)),
          bd: c.n1(theme),
          filter: 'none'
        };
    }
  },
  active(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.black(theme),
          bg: c.hcStandardSelected(theme),
          bd: 'transparent',
          filter: 'none'
        };
      case 'marine':
      case 'sail':
        return {
          fg: c.n_3(theme),
          bg: c.n3(theme),
          bd: c.n1(theme),
          filter: 'none'
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: c.white(theme),
          bg: transparentize(0.85, c.white(theme)),
          bd: c.white(theme),
          filter: 'none'
        };
      case 'high-contrast':
        return {
          fg: c.black(theme),
          bg: c.white(theme),
          bd: 'transparent',
          filter: 'none'
        };
      default:
        return {
          fg: c.n_3(theme),
          bg: transparentize(0.75, c.n1(theme)),
          bd: c.n1(theme),
          filter: 'none'
        };
    }
  },
  selected(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.black(theme),
          bg: c.hcStandardSelected(theme),
          bd: 'transparent',
          filter: 'none'
        };
      case 'marine':
      case 'sail':
        return {
          fg: c.n_3(theme),
          bg: c.p3(theme),
          bd: c.n1(theme),
          filter: 'none'
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: c.white(theme),
          bg: transparentize(0.85, c.white(theme)),
          bd: c.white(theme),
          filter: 'none'
        };
      case 'high-contrast':
        return {
          fg: c.black(theme),
          bg: c.white(theme),
          bd: 'transparent',
          filter: 'none'
        };
      default:
        return {
          fg: c.n_3(theme),
          bg: transparentize(0.75, c.n1(theme)),
          bd: c.n1(theme),
          filter: 'none'
        };
    }
  },
  selectedInactive(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.black(theme),
          bg: c.hcStandardSelectedInactive(theme),
          bd: 'transparent',
          filter: 'none'
        };
      case 'marine':
      case 'sail':
        return {
          fg: c.n_3(theme),
          bg: c.n3(theme),
          bd: c.n1(theme),
          filter: 'none'
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: c.white(theme),
          bg: transparentize(0.9, c.white(theme)),
          bd: 'transparent',
          filter: 'none'
        };
      case 'high-contrast':
        return {
          fg: c.black(theme),
          bg: c.white60(theme),
          bd: 'transparent',
          filter: 'none'
        };
      default:
        return {
          fg: c.n_3(theme),
          bg: transparentize(0.8, c.n1(theme)),
          bd: 'transparent',
          filter: 'none'
        };
    }
  },
  disabled(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.hcDisabled(theme),
          bg: c.black(theme),
          bd: c.hcDisabled(theme),
          filter: 'none'
        };
      case 'marine':
      case 'sail':
        return {
          fg: c.n1(theme),
          bg: c.white(theme),
          bd: c.n3(theme),
          filter: 'none'
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: transparentize(0.8, c.white(theme)),
          bg: 'transparent',
          bd: transparentize(0.8, c.white(theme)),
          filter: 'none'
        };
      case 'high-contrast':
        const {
          fg,
          bg,
          bd
        } = stateStandard.normal(theme);
        return {
          fg: transparentize(0.5, fg),
          bg: transparentize(0.5, bg),
          bd: transparentize(0.5, bd),
          filter: 'none'
        };
      default:
        return {
          fg: c.n2(theme),
          bg: 'transparent',
          bd: c.n2(theme),
          filter: 'none'
        };
    }
  }
};

/**
 * @see http://livingston.sas.com/10-0/essentials/standard/
 */
export const stateStandardContent = {
  normal(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.white(theme),
          bg: c.black(theme),
          filter: 'none'
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: c.white(theme),
          bg: 'transparent',
          filter: 'none'
        };
      case 'high-contrast':
        return {
          fg: c.white(theme),
          bg: 'transparent',
          filter: 'none'
        };
      default:
        return {
          fg: c.n_3(theme),
          bg: 'transparent',
          filter: 'none'
        };
    }
  },
  hover(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.hcStandardSelected(theme),
          bg: c.hcStandardHover(theme),
          filter: 'none'
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: c.white(theme),
          bg: transparentize(0.9, c.white(theme)),
          filter: 'none'
        };
      case 'high-contrast':
        return {
          fg: c.white(theme),
          bg: c.n_3(theme),
          filter: 'none'
        };
      default:
        return {
          fg: c.n_3(theme),
          bg: transparentize(0.8, c.n1(theme)),
          filter: 'none'
        };
    }
  },
  active(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.black(theme),
          bg: c.hcStandardSelected(theme),
          filter: 'none'
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: c.white(theme),
          bg: transparentize(0.85, c.white(theme)),
          filter: 'none'
        };
      case 'high-contrast':
        return {
          fg: c.black(theme),
          bg: c.white(theme),
          filter: 'none'
        };
      default:
        return {
          fg: c.n_3(theme),
          bg: transparentize(0.75, c.n1(theme)),
          filter: 'none'
        };
    }
  },
  selected(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.black(theme),
          bg: c.hcStandardSelected(theme),
          filter: 'none'
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: c.white(theme),
          bg: transparentize(0.85, c.white(theme)),
          filter: 'none'
        };
      case 'high-contrast':
        return {
          fg: c.black(theme),
          bg: c.white(theme),
          filter: 'none'
        };
      default:
        return {
          fg: c.n_3(theme),
          bg: transparentize(0.75, c.n1(theme)),
          filter: 'none'
        };
    }
  },
  selectedInactive(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.black(theme),
          bg: c.hcStandardSelectedInactive(theme),
          filter: 'none'
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: c.white(theme),
          bg: transparentize(0.9, c.white(theme)),
          filter: 'none'
        };
      case 'high-contrast':
        return {
          fg: c.black(theme),
          bg: c.white60(theme),
          filter: 'none'
        };
      default:
        return {
          fg: c.n_3(theme),
          bg: transparentize(0.8, c.n1(theme)),
          filter: 'none'
        };
    }
  },
  disabled(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.hcDisabled(theme),
          bg: c.black(theme),
          filter: 'none'
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: transparentize(0.8, c.white(theme)),
          bg: 'transparent',
          filter: 'none'
        };
      case 'high-contrast':
        return {
          fg: transparentize(0.5, c.white(theme)),
          bg: 'transparent',
          filter: 'none'
        };
      default:
        return {
          fg: c.n2(theme),
          bg: 'transparent',
          filter: 'none'
        };
    }
  }
};

/**
 * Temporary doc until the new Design System site is up
 * @see https://gitlab.sas.com/novacommons/nova-tokens/-/tree/master/tokens
 */
export const stateStandardNova = {
  normal(theme) {
    return {
      fg: c.colorTextDefault(theme),
      bg: setAlpha(c.colorNeutral(theme), 0.08),
      bd: c.colorNeutral(theme),
      filter: 'none'
    };
  },
  hover(theme) {
    return {
      fg: c.colorTextDefault(theme),
      bg: setAlpha(c.colorNeutral(theme), 0.2),
      bd: c.colorNeutral(theme),
      filter: 'none'
    };
  },
  active(theme) {
    switch (theme.baseThemeName) {
      case 'high-contrast':
        return {
          fg: c.colorTextDefault(theme),
          bg: c.colorUiLight(theme),
          bd: c.colorUiLight(theme),
          filter: 'invert(1) grayscale(1)'
        };
      default:
        return {
          fg: c.colorTextDefault(theme),
          bg: setAlpha(c.colorNeutral(theme), 0.25),
          bd: c.colorNeutral(theme),
          filter: 'none'
        };
    }
  },
  selected(theme) {
    switch (theme.baseThemeName) {
      case 'high-contrast':
        return {
          ...stateStandardNova.active(theme),
          filter: 'invert(1) grayscale(1)'
        };
      default:
        return stateStandardNova.active(theme);
    }
  },
  selectedInactive(theme) {
    switch (theme.baseThemeName) {
      case 'high-contrast':
        return {
          ...stateStandardNova.selected(theme),
          filter: 'invert(0.85) grayscale(1)'
        };
      default:
        return {
          fg: c.colorTextDefault(theme),
          bg: setAlpha(c.colorNeutral(theme), 0.2),
          bd: 'transparent',
          filter: 'none'
        };
    }
  },
  disabled(theme) {
    switch (theme.baseThemeName) {
      case 'high-contrast':
        return {
          fg: setAlpha(c.colorTextDefault(theme), 0.48),
          bg: setAlpha(c.colorNeutral(theme), 0.16),
          bd: 'transparent',
          filter: 'none'
        };
      default:
        return {
          fg: setAlpha(c.colorTextDefault(theme), 0.32),
          bg: setAlpha(c.colorNeutral(theme), 0.08),
          bd: 'transparent',
          filter: 'none'
        };
    }
  }
};

/**
 * Temporary doc until the new Design System site is up
 * @see https://gitlab.sas.com/novacommons/nova-tokens/-/tree/master/tokens
 */
export const stateStandardContentNova = {
  normal(theme) {
    const sourceTokens = stateStandardNova.normal(theme);
    return {
      ...sourceTokens,
      bg: 'transparent',
      bd: 'transparent'
    };
  },
  hover(theme) {
    const sourceTokens = stateStandardNova.hover(theme);
    return {
      ...sourceTokens,
      bd: 'transparent'
    };
  },
  active(theme) {
    const sourceTokens = stateStandardNova.active(theme);
    return {
      ...sourceTokens,
      bd: 'transparent'
    };
  },
  selected(theme) {
    const sourceTokens = stateStandardNova.selected(theme);
    return {
      ...sourceTokens,
      bd: 'transparent'
    };
  },
  selectedInactive(theme) {
    const sourceTokens = stateStandardNova.selectedInactive(theme);
    return {
      ...sourceTokens,
      bd: 'transparent'
    };
  },
  disabled(theme) {
    const sourceTokens = stateStandardNova.disabled(theme);
    return {
      ...sourceTokens,
      bg: 'transparent',
      bd: 'transparent'
    };
  }
};
//# sourceMappingURL=standard-states.js.map